
export const COLOR_PALLET = {
    PRIMARY: "#244da1",
    PRIMARY_LIGHT: "#1d4392",
    SECONDARY: "#6c757d",
    SECONDARY_LIGHT: "#596169",
    DANGER: "#bf2527",
    DANGER_OUTLINE: "#bf2527",
    DANGER_LIGHT: "#D93D3F",
    SUCCESS: "#007204",
    SUCCESS_LIGHT: "3d9140",
}

